import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

import type { UploadDocumentEvents } from '@data-access/documents/types';
import type { FailedDocument, UploadState } from '@data-access/submissions';

export const UPLOAD_DOCUMENT_EVENTS: UploadDocumentEvents = eventGroup({
  events: {
    documentUploadStatusReceived: type<{
      documentTitle: string | null;
      status: UploadState;
    }>(),
    uploadFailedDocumentsReceived: type<{
      failedDocuments: FailedDocument[];
    }>(),
  },
  source: 'Upload Document Signal Store',
});
